// export const SET_MODAL_CART = 'SET_MODAL_CART';
export const SET_MODAL_AUTH_REG = 'SET_MODAL_AUTH_REG';
export const SET_MODAL_POPUP = 'SET_MODAL_POPUP';
export const SET_MODAL_ORDER = 'SET_MODAL_ORDER';
